import { isWebsiteBuilderFlex, IWebsiteBuilderFlex } from "./container/websiteBuilderFlex";
import { IWebsiteBuilderGridCell } from "./gridCell/websiteBuilderGridCell";

export type TWebsiteBuilderFlowParentNode =
  | IWebsiteBuilderFlex
  | IWebsiteBuilderGridCell;

export function isWebsiteBuilderFlowParentNode(node: any): node is TWebsiteBuilderFlowParentNode {
  return isWebsiteBuilderFlex(node) || node?.type === "grid-cell";
}
